import { CalendarMonth, ChevronLeft, ChevronRight, KeyboardArrowDown, Print } from '@mui/icons-material'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useGET_groupCourseSessionsQuery } from 'redux/api/sessionsApi'
import { dayOfWeek, formatTime, printDiv } from 'utils/helpers'
import { format } from 'date-fns'
import _ from 'lodash'
import Assignments from './Assignments'
import SectionSubjectLessons from './SectionSubjectLessons'
import { Switch } from '@mui/material'

const SectionMySchedule: FC = () => {
  const { t } = useTranslation()  

  const [groups, setGroups] = useState([])
  const [expanded, setExpanded] = useState([])
  const [date, setDate] = useState(new Date)
  const [dateLabel, setDateLabel] = useState("")

  const getDateLabel = (d) => {
    if(!d)return "";
    const today = new Date
    return (d.getDate() === today.getDate()) ? t('common.today') : dayOfWeek(d)
  }

  const toggleExpanded = (g) => {
    if(expanded.includes(g)){
      const newExpanded = expanded.filter(e => e !== g)
      setExpanded(newExpanded)
    }
    else{
      const newExpanded = [...expanded, g]
      setExpanded(newExpanded)
    }  
  }

  const toggleExpandAll = () => {
    if(expanded.length == groups.length){
      setExpanded([])
    }
    else{
      setExpanded(groups.map(g => g.id))
    }
      
  }

  const prevDay = () => {
    date.setDate(date.getDate() - 1)   
    setDate(date)
    setDateLabel(getDateLabel(date))
  }

  const nextDay = () => {
    date.setDate(date.getDate() + 1)
    setDate(date)
    setDateLabel(getDateLabel(date))
  }
  
  const { data: sessions } = useGET_groupCourseSessionsQuery({ 
    page: 1, 
    page_size: 24, 
    ordering: 'start_datetime', 
    start_date_from: format(date, 'yyyy-MM-dd'),
    start_date_to: format(date, 'yyyy-MM-dd'),
  },{skip: !date})
  
  useEffect(() => {
    if(sessions?.results){
      const newGroups = []
      for(const s of sessions.results.filter(s => !!s.plan?.id)){
        if(!newGroups.map(g => g.id).includes(s.course_id)){
          newGroups.push({
            id: s.course_id,
            title: s.course,
            start: s.start_datetime,
            sessions: []
          })
        }
        newGroups.find(g => s.course_id == g.id).sessions.push(s)
      }
      setGroups(newGroups)
    }
  }, [sessions])

  useEffect(() => {
    setDateLabel(t('common.today'))
  }, [])

 
  return (
     <div>


        <div style={{ display: 'flex', alignItems: 'center', width: '100%', marginBottom: '20px' }}>
          <div style={{ width: '40%' }}>
            <h1 className='workspace-title'>{t('dashboard.my-schedule-today')}</h1>
          </div>
          <div style={{display: 'flex', gap: '10px', width: '20%', justifyContent: 'center', alignItems: 'center' }}>
              <div><ChevronLeft color='primary' sx={{cursor: 'pointer'}} onClick={() => prevDay()}/></div>
              <div style={{display: 'flex', flexDirection: 'column', textAlign: 'center'}}>
                <div style={{ fontSize: '20px', fontWeight: 500, textTransform: 'capitalize' }}>{dateLabel}</div>
                <div>{format(date, 'dd/MM/yyy')}</div>
              </div>
              <div><ChevronRight color='primary' sx={{cursor: 'pointer'}} onClick={() => nextDay()}/></div>
          </div>
          <div style={{ width: '40%', display: 'flex', alignItems: 'center', justifyContent: 'right', gap: '10px' }}>
              <div><Print sx={{ cursor: 'pointer', position: 'relative', bottom: '-4px' }} 
                onClick={() => { printDiv('print-daily-schedule') }} /></div>
              <div>
                <Switch
                  checked={expanded.length == groups.length}
                  onClick={() => toggleExpandAll()}
                  color={'primary'}
                  sx={{ '& .MuiSvgIcon-root': { fontSize: '2rem' } }}
                />
                {t('common.expand-all')}
              </div>
          </div>
        </div>

        {groups.length === 0 && <div>{t('empty.sessions')}</div>}

        {groups.map( g => <div key={g.id} className='subject-group'>
                    <div className='subject-group-line'  onClick={() => toggleExpanded(g.id)}>
                      <div className="subject-group-title">{g.title}</div>
                      <div className="subject-group-icons">
                        <CalendarMonth sx={{ fontSize: '30px', position: 'relative' }} />
                        <span>{formatTime(g.start)}</span>
                        <KeyboardArrowDown sx={{ fontSize: '30px', }} />
                      </div>
                    </div>
                    {expanded.includes(g.id) && <div className='subject-group-content'>
                        <SectionSubjectLessons sessions={g.sessions} />  
                        <Assignments /> 
                    </div>}
        </div>)}


        <div style={{display:'none'}} id='print-daily-schedule'>
          {groups.map(g=> <div key={g.id} style={{ border: '1px dashed #000', padding: '20px', marginBottom: '20px' }}>
              <div style={{ display: 'flex', width: '100%', gap: '10px'}}>
                <div style={{fontSize: '18px', fontWeight: '500'}}>{g.title}</div>
                <div style={{marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '5px'}}>
                  <CalendarMonth sx={{ fontSize: '20px' }} /> 
                  <span>{formatTime(g.start)}</span>
                </div>
              </div>
              <div>
                <SectionSubjectLessons print sessions={g.sessions} />  
              </div>
          </div>)}
        </div>
     </div>
  )
}

export default SectionMySchedule
